<template>
  <div>
  <div v-if="piecesJointes && piecesJointes.length">
    <div>
      <table class="table pj-table is-fullwidth">
        <thead>
        <tr>
          <th class="has-text-link">{{ $t('piecesJointes.table.fileName') }}</th>
          <th class="has-text-link">{{ $t('piecesJointes.table.type') }}</th>
          <th class="has-text-link">{{ $t('piecesJointes.table.description') }}</th>
          <th v-if="!readOnly"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="piecesJointe in piecesJointes" :key="piecesJointe.id">
          <td>
            <a v-if="piecesJointe.thumb" @click.prevent="showPj(piecesJointe)" target="_blank">
              <img class="is-pulled-left image is-64x64" :src="piecesJointe.thumb"/>
            </a>
            <a v-else-if="piecesJointe.chemin
              && (/\.(gif|jpg|jpeg|tiff|png)$/i).test(piecesJointe.nom)"
               :href="`${piecesJointe.chemin}`"
            target="_blank">
            <img class="is-pulled-left image is-64x64"
                 :src="`${piecesJointe.cheminMin || piecesJointe.chemin}`"/>
            </a>
            <a v-else-if="piecesJointe.chemin"
               :href="`${piecesJointe.chemin}`"
            target="_blank">
              <img class="is-pulled-left image is-64x64"
                   :src="`/static/icons/svg/${getFormat(piecesJointe.nom)}.svg`">
            </a>
            <a v-else @click.prevent="showPj(piecesJointe)" target="_blank">
              <img class="is-pulled-left image is-64x64"
                 :src="`/static/icons/svg/${getFormat(piecesJointe.nom)}.svg`"></a>
            <div class="is-pulled-left mgl-10px">
              <p class="has-text-grey-light has-text-weight-semibold">
                {{piecesJointe.nom}}
                <b-tag
                  v-if="piecesJointe.placeType === PIECE_JOINTE_TYPE_HISTORIQUE_LOGO"
                  type="is-subMenu"
                  class="has-text-white mgl-5px">
                  {{ $t('piecesJointes.historique') }}
                </b-tag>
              </p>
              <p class="is-size-7">{{piecesJointe.size | formatSize}} -
                {{piecesJointe.creationTime | formatDate}}</p>
            </div>
          </td>
          <td v-if="readOnly">
            {{ formatPjType(piecesJointe.typeId) }}
          </td>
          <td class="width-250" v-else>
            <b-select v-model="piecesJointe.typeId"
                      expanded
                      :placeholder="$t('piecesJointes.modal.selectType')"
                      :disabled="!canDeletePj(piecesJointe)">
              <option :value="null"></option>
              <option
                v-for="type in typesPiecesJointes"
                :value="type.id"
                :key="type.id">
                {{ type.libelle }}
              </option>
            </b-select>
          </td>
          <td v-if="readOnly">
            {{piecesJointe.description}}
          </td>
          <td v-else>
            <b-input v-model="piecesJointe.description"></b-input>
          </td>
          <td v-if="(!readOnly || deletable) && canAddOrDeletePj">
            <b-tooltip
              :label="$t('piecesJointes.impossibleDeSupprimerPj')"
              :active="!canDeletePj(piecesJointe)"
              position="is-left">
              <a @click="(checkPermissions || canDeletePj(piecesJointe))
                ? openPopUpSuppresion(piecesJointe) : showPopUp()"
                :class="canDeletePj(piecesJointe)
                  ? 'is-cursor-pointer' : 'pointer-events-none'">
                <b-icon
                  icon="delete-forever"
                  type="is-danger"
                  :disabled="!canDeletePj(piecesJointe)"
                  :class="{'text-access-no-permission' : !checkPermissions
                    || !canDeletePj(piecesJointe) }">
                </b-icon>
              </a>
            </b-tooltip>
          </td>
        </tr>
        <tr></tr>
        </tbody>
      </table>
    </div>
  </div>
    <div v-else class="card-article-any has-background-background
    card-content has-text-centered border-card-nothing"
    >
      <br>
      <h1 class="title is-size-4">
        {{ $t('piecesJointes.aucunAttachement')}}
      </h1>
      <a class="lien" @click="showAddModal = true" v-if="canAddPj && canAddOrDeletePj">
        {{ $t('piecesJointes.addAttachement')}}
      </a>
    </div>
    <b-modal v-model="showAddModal"
             has-modal-card
             class="modal">
      <app-ajout-piece-jointe :autoSave="autoSave" :checkPerm="checkPermissions"/>
    </b-modal>
    <b-modal v-model="popUpSuppresion" has-modal-card class="modal">
      <pop-up-prevention :mess-header="$t('general.popUpSuppresionPjImage.title.pj')"
        :mess-footer="autoSave ?
        $t('general.popUpSuppresionPjImage.sousTitle.detail') :
        $t('general.popUpSuppresionPjImage.sousTitle.edition')"
        :cancel="$t('general.button.cancel')"
        :validate="$t('general.button.next')"
        :isErrorPopup.sync="isErrorPopup"
        :messagesPopup="messages"
        @no="popUpSuppresion=false"
        @yes="supprimerFichier()">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { TEXTS, RESULTS_PER_PAGE, NO_PER_PAGE_VALUE } from '@/configuration/clientTableConf';
import { FORMAT_ICON, FORMAT_ICON_DIVERS, PIECE_JOINTE_TYPE_HISTORIQUE_LOGO } from '@/configuration/general/pieceJointeConf';
import * as types from '@/store/modules/attachments-mutation-type';
import AjoutPieceJointe from '@/components/general/ajoutPieceJointe';
import inProgress from '@/services/general/inProgress';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import popUpPrevention from '@/components/general/popUpPrevention';
import validation from '@/services/general/validation/validationPieceJointe';

const Attachments = createNamespacedHelpers('attachments');
const permissions = createNamespacedHelpers('permissions');

export default {
  name: 'piecesJointes',
  props: {
    checkPermissions: {
      type: Boolean,
    },
    readOnly: {
      type: Boolean,
    },
    deletable: {
      type: Boolean,
    },
    autoSave: {
      type: Boolean,
    },
    canAddPj: {
      type: Boolean,
      required: false,
      default: true,
    },
    canAddOrDeletePj: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  components: {
    AppAjoutPieceJointe: AjoutPieceJointe,
    popUpPrevention,
  },
  data() {
    return {
      currentPage: 1,
      files: [],
      piecesjaunes: [],
      popUpSuppresion: false,
      pjToDelete: null,
      isErrorPopup: false,
      messages: [],
      PIECE_JOINTE_TYPE_HISTORIQUE_LOGO,
    };
  },
  computed: {
    ...Attachments.mapGetters({
      getShowAddModal: 'showAddModal',
      piecesJointes: 'piecesJointes',
      typesPiecesJointes: 'typesPiecesJointes',
    }),
    showAddModal: {
      get() {
        return this.getShowAddModal;
      },
      set(value) {
        this.setShowAddModal(value);
      },
    },
    columns() {
      return ['nom', 'description', 'type', 'supprimer'];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        headings: {
          nom: this.$i18n.t('editionClient.table.name'),
          description: this.$i18n.t('editionClient.table.description'),
          type: this.$i18n.t('editionClient.table.type'),
          supprimer: this.$i18n.t('editionClient.table.delete'),
        },
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        filterable: false,
      };
    },
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Attachments.mapMutations({
      setShowAddModal: types.SET_SHOW_ADD_MODAL,
      removeAttachments: types.REMOVE_PIECE_JOINTE,
    }),
    ...Attachments.mapActions({
      removeAttachmentsBackend: 'delete',
    }),
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    openPopUpSuppresion(file) {
      this.isErrorPopup = false;
      this.messages = [];
      this.popUpSuppresion = true;
      this.pjToDelete = file;
    },
    async supprimerFichier() {
      this.isErrorPopup = false;
      this.messages = [];
      if (this.canDeletePj(this.pjToDelete)) {
        this.removeAttachments(this.pjToDelete.id);
      }
      if (this.autoSave) {
        const loadingComponent = this.$buefy.loading.open();
        try {
          await this.removeAttachmentsBackend(this.pjToDelete.id);
          const messageToast = this.$i18n.t('piecesJointes.messages.deleteSuccess');
          messageSucces(messageToast);
          loadingComponent.close();
        } catch (e) {
          if (e.response && e.response.data.error) {
            validation(e.response, this.messages);
            this.isErrorPopup = true;
            loadingComponent.close();
            return;
          }
          loadingComponent.close();
          messageErreur(this.$i18n);
          throw (e);
        }
      }
      this.popUpSuppresion = false;
    },
    selectType(props) {
      this.piecesJointes.splice(this.piecesJointes.indexOf(
        this.piecesJointes.find((el) => { return el.id === props.id; }),
      ), 1, props);
    },
    formatPjType(value) {
      if (!value) {
        return '';
      }
      const type = this.typesPiecesJointes.find(tpj => tpj.id === value);
      return type ? type.libelle : '';
    },
    getFormat(nameAttachement) {
      const extention = nameAttachement.split('.').pop();
      const formatIcon = FORMAT_ICON.find(f => f === extention);
      if (formatIcon) return formatIcon;
      return FORMAT_ICON_DIVERS;
    },
    showPj(pj) {
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(pj.file);
      } else {
        window.URL = window.URL || window.webkitURL;
        const fileURL = URL.createObjectURL(pj.file);
        window.open(fileURL);
      }
    },
    canDeletePj(pj) {
      const findType = this.typesPiecesJointes.find(type => type.id === pj.typeId);
      return findType?.pieceSupprimable ?? true;
    },
  },
};
</script>

<style scoped type="scss">
  table {
    border-spacing: 0px 13px;
    border-collapse: separate;
  }
  td {
    padding: 0;
    border-style: solid;
    border-width: 2px 0;
    margin-bottom: 10px;
    padding: 10px;
    border-color: $white-ter;
  }

  td:first-child {
    border-left-width: 2px;
    width: 50%;
  }
  td:last-child {
    border-right-width: 2px;
  }
  th {
    border-width: 0 !important;
  }
</style>
